import { getContext } from '@fiverr-private/fiverr_context';

const COLLECT_PACKAGE = 'collect_package';

export const getLoggingContext = () => {
    const { userId } = getContext();

    return {
        userId,
        context: COLLECT_PACKAGE
    };
};
